import * as React from 'react';
import { Button, FormGroup } from 'reactstrap';
import { useEffect, useState } from 'react';
import { Communicator } from '../../tools/Communication';
import { ConfigTextarea } from './styled';

export default function EditConfigPage() {
  const [autoStockMinMaxConfig, setAutoStockMinMaxConfig] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    Communicator.Get('/Config/GetConfigValue?key=AutoStockMinMaxConfig', {})
      .then((response) => response.text())
      .then((text) => setAutoStockMinMaxConfig(text));
  }, []);

  async function saveAutoStockMinMaxConfig() {
    setIsLoading(true);
    try {
      console.log({ autoStockMinMaxConfig });
      const result = await Communicator.PostData('/Config/SetConfigValue', {
        Key: 'AutoStockMinMaxConfig',
        Value: autoStockMinMaxConfig,
      });
      setAutoStockMinMaxConfig(await result.text());
    } catch (e) {
      alert('Error saving config');
    }
    setIsLoading(false);
  }

  let isValidJson = false;
  try {
    JSON.parse(autoStockMinMaxConfig);
    isValidJson = true;
  } catch {}

  return (
    <div className="p-3">
      <h4>Edit Config: Auto Store Stock Min/Max/Turnover Update</h4>
      <FormGroup>
        <ConfigTextarea
          type="textarea"
          name="text"
          value={autoStockMinMaxConfig}
          rows="8"
          spellCheck={false}
          autoComplete="off"
          onChange={(e: any) => setAutoStockMinMaxConfig(e.target.value)}
        />
      </FormGroup>

      <Button
        color="primary"
        size="sm"
        disabled={!isValidJson}
        onClick={saveAutoStockMinMaxConfig}
      >
        {isLoading ? 'Saving...' : 'Save'}
        {!isValidJson && ' (config is invalid)'}
      </Button>
    </div>
  );
}
